// auth.guard.ts
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class OrganisationGuard  {

  constructor(private router: Router) { }

  canActivate(): boolean {
    if (sessionStorage.getItem("organisationId")==null) {
        this.router.navigate(['/login']);
        return false;
    } else {
        return true;
    }
  }
}